import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=400b7c08&"
import script from "../../models/customers/download.ts?vue&type=script&lang=ts&"
export * from "../../models/customers/download.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports